export class EmbeddedURLRequestModel {
  appId: string = '';
  metadata?: any = {};
}
